import { constants } from 'app/entities/EnvironmentVariable';

export const commonFields = [
  {
    label: 'Test',
    key: 'test',
    type: 'request-editor',
    required: true,
    helpText:
      'Enter an API endpoint URL to test authentication credentials, ideally one needing no configuration such as <code>/me</code>.',
  },
];

export const commonFieldKeys: Array<string> = commonFields.map(f => f.key);

export const credentialFields = {
  oauth2: [
    {
      label: 'Client ID',
      key: constants.OAUTH_CLIENT_ID,
      type: 'text-input',
      required: true,
      helpText: `Copy Client ID from your app and enter here; may also be called Consumer Key or API Key. Referenced in Zapier requests as <code>{{process.env.${constants.OAUTH_CLIENT_ID}}}</code>.`,
      env: true,
    },
    {
      label: 'Client Secret',
      key: constants.OAUTH_CLIENT_SECRET,
      type: 'text-input',
      required: true,
      helpText: `Copy Client Secret from your app and enter here; may also be called Consumer Secret or API Secret. Referenced in Zapier requests as <code>{{process.env.${constants.OAUTH_CLIENT_SECRET}}}</code>.`,
      env: true,
    },
  ],
};

const configScopeField = {
  label: 'Scope',
  key: 'scope',
  type: 'text-input',
  helpText:
    'If you want to limit Zapier’s access to your app data, define the OAuth scopes with a comma or space separated list of values.',
};

const configAutoRefreshTokenField = {
  label: 'Automatically Refresh Token',
  key: 'autoRefresh',
  type: 'boolean-input',
  helpText:
    'Should Zapier invoke your <code>refreshAccessToken</code> request automatically when we receive a 401 response?',
  boolHelpText: 'I want to automatically refresh on unauthorized error.',
};

export const configFields = {
  oauth2: [
    {
      label: 'Authorization URL',
      key: 'authorizeUrl',
      type: 'request-editor',
      required: true,
      helpText: 'Specify where to send users to authenticate with your API.',
      removeNonRedirectParams: true,
      extraProps: {
        codeIsUrlOnly: true,
      },
    },
    configScopeField,
    {
      label: 'Access Token Request',
      key: 'getAccessToken',
      type: 'request-editor',
      required: true,
      helpText:
        'Enter the API endpoint URL where Zapier sends the approval code on user redirect, typically via <code>POST</code>, and receives <code>access_token</code> in the response.',
    },
    {
      label: 'Refresh Token Request',
      key: 'refreshAccessToken',
      type: 'request-editor',
      helpText:
        'Enter the API endpoint URL where Zapier can request a refreshed access token when a <code>RefreshAuthError</code> error is thrown.',
    },
    configAutoRefreshTokenField,
  ],
};

export const configFieldsLegacy = {
  oauth2: [
    {
      label: 'Authorization URL',
      key: 'authorizeUrl',
      type: 'text-input',
      required: true,
      helpText:
        'Where we redirect users when they attempt to connect to Zapier. We will construct and append the querystring for you.',
    },
    configScopeField,
    {
      label: 'Access Token URL',
      key: 'accessTokenUrl',
      type: 'text-input',
      required: true,
      helpText:
        'Where we POST the approval <code>code</code> when a user is redirected back to Zapier. Expects <code>access_token</code> in the response.',
    },
    {
      label: 'Refresh Token URL',
      key: 'refreshTokenUrl',
      type: 'text-input',
      required: false,
      helpText: 'Where we POST to refresh an <code>access_token</code>.',
    },
    configAutoRefreshTokenField,
  ],
};

export const tokenExchangeFields = {
  session: [
    {
      label: 'Token Exchange Endpoint',
      key: 'perform',
      type: 'request-editor',
      required: true,
      helpText:
        'Enter a request URL to exchange the credentials supplied by the user for a session token. Zapier will execute this request each time your API returns an HTTP 401 response.',
      extraProps: {
        codeReturnKeys: ['sessionKey'],
      },
    },
  ],
};
